import BaseService from '@root/core/class/BaseService';
import warehouse from '@root/modules/Warehouse/Dasboard/services/warehouse';
import { IPagination } from '../../../Sellers/Product/interfaces'

class buskService extends BaseService {
  public getListWarehouse = (
    page: number,
    fromDt?: string,
    toDt?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    let inputUse = !!input ? (input.replaceAll("%","%25")).replaceAll("#","%23") : "" 
    let url = `/stock-warehouses?page=${page}&limit=10` + 
              (!!inputUse  ? '&search=' + `${inputUse}` : '&search=') +
              (!!fromDt ? '&fromDt=' + `${fromDt}`: '&fromDt=') +
              (!!toDt ? '&toDt=' + toDt : '&toDt=') +
              (!!filter ? '&searchBy=' + `${filter}` : '&searchBy=') +
              (!!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC')
    return this.get(
      url
    );
  };
  
  //api export excel all of list warehouse
  public exportExcelWarehouse = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt,
  }: IPagination) => {
    let fieldSearchUse = !!fieldSearch ? (fieldSearch.replaceAll("%","%25")).replaceAll("#","%23") : "" 
    let url = `/stock-warehouses/export?`;
    url +=   ((!!productName  &&
              !!fieldSearchUse) ?`&searchBy=`+productName + `&search=` + fieldSearchUse:'&searchBy=&search=')
              + (!!fromDt ? `&fromDt=${fromDt}` : '&fromDt=')
              + (!!toDt ? `&toDt=${toDt}` : '&toDt=')
              + (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC` );
    let urlUse = url.replace('?&','?')
    return this.post(
      urlUse,
      {},
      {
        responseType: "blob",
      }
    );
  };

  public exportWarehouseExcellById = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt,
    listId
  }: IPagination) => {
    let fieldSearchUse = !!fieldSearch ? (fieldSearch.replaceAll("%","%25")).replaceAll("#","%23") : "" 
    let url = `/stock-warehouses/export?`;
    url +=   ((!!productName  &&
              !!fieldSearchUse) ?`&searchBy=`+productName + `&search=` + fieldSearchUse:'&searchBy=&search=')
              + (!!fromDt ? `&fromDt=${fromDt}` : '&fromDt=')
              + (!!toDt ? `&toDt=${toDt}` : '&toDt=')
              + (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC` );
    let urlUse = url.replace('?&','?')
    return this.post(
      urlUse,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public getListStockOfWarehouse = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    return this.get(
      `/stock-warehouses?page=${page}&limit=10${
        Boolean(state) ? '&filterBy=state:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + input : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`
    );
  };
}

export default new buskService('/api/v1/admin', true);
